import {useState} from "react";
import {useDispatch} from "react-redux";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {castToValidationError} from "@pg-mono/react-hook-forms-utils";
import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils/src/utils/is_fetch_base_query_error";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Currency} from "../../../types/Currency";
import {appendMultiLeadApplicationsForOffers, appendMultiLeadApplicationsForProperties} from "../../actions/multi_lead/append_multi_lead_applications";
import {RecommendedOfferApplicationsType} from "../../actions/multi_lead/track_recommended_offers_application";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {applicationMultiLeadSendOffer} from "../../utils/multi_lead/application_multi_lead_send_offer";
import {applicationMultiLeadSendProperty} from "../../utils/multi_lead/application_multi_lead_send_property";
import {useMultiLeadData} from "./use_application_multi_lead_data";
import {useMultiLeadRecommendations} from "./use_application_multi_lead_recommendations";

interface IProps {
    storeHash: string;
    recommendationType: ApplicationMultiLeadRecommendationType;
    sourceSection: ApplicationSourceSection;
    originalApplicationFormValues: IApplicationFormValues | null;
    recommendationsWithPriceFilter: boolean;
    customSourceSection?: string;
    currency?: Currency;
    castRtkError?: (error: FetchBaseQueryError) => void;
}

type ISendMultiLeadFormParams =
    | {
          selectedRecommendations: number[];
          recommendedProperties?: never;
          recommendedOffers?: never;
          formValues: IApplicationFormValues;
      }
    | {
          selectedRecommendations?: never;
          recommendedProperties?: IRecommendedProperty[];
          recommendedOffers?: IRecommendedOffer[];
          formValues: IApplicationFormValues;
      };

export interface IMultiLeadApiErrors {
    fieldErrors?: {
        [key: string]: string[];
    };
    nonFieldErrors?: string[];
    status: number;
}

export const useMultiLeadFormSend = (props: IProps) => {
    const dispatch = useDispatch();
    const [isMultiLeadSending, setMultiLeadSending] = useState(false);
    const [sentPropertiesApplications, setSentPropertiesApplications] = useState<ApplicationMultiLeadRecommendedPropertyType[]>([]);

    const {applicationData, viewType, isAuthenticated} = useMultiLeadData(props);
    const {recommendedOffers, recommendedProperties} = useMultiLeadRecommendations({
        propertyId: applicationData?.property?.detail?.id,
        offerId: applicationData?.offer?.detail?.id
    });
    const refererApplicationUUID = applicationData?.application?.uuid;

    const sendMultiLeadForm = async (
        sendMultiLeadFormParams: ISendMultiLeadFormParams
    ): Promise<ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]> => {
        setMultiLeadSending(true);

        const metadata = {
            sourceSection: props.sourceSection,
            viewType,
            isAuthenticated,
            application: applicationData?.application,
            refererApplicationUUID,
            originalFormParams: {
                rooms: props.originalApplicationFormValues?.rooms || [],
                questions: props.originalApplicationFormValues?.questions || []
            },
            recommendationsWithPriceFilter: props.recommendationsWithPriceFilter,
            currency: props.currency
        };

        if (props.recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY) {
            return applicationMultiLeadSendProperty(
                {
                    recommendedProperties:
                        "recommendedProperties" in sendMultiLeadFormParams && sendMultiLeadFormParams.recommendedProperties
                            ? sendMultiLeadFormParams.recommendedProperties || []
                            : recommendedProperties.filter((property) => sendMultiLeadFormParams.selectedRecommendations?.includes(property.id)),
                    formValues: sendMultiLeadFormParams.formValues
                },
                metadata,
                props.customSourceSection
            )(dispatch)
                .then((response) => {
                    appendMultiLeadApplicationsForProperties(props.storeHash, response)(dispatch);

                    setSentPropertiesApplications((prev) => [...prev, ...response]);

                    return response;
                })
                .catch((error) => {
                    if (isFetchBaseQueryError(error) && error.status === 400) {
                        throw props.castRtkError ? props.castRtkError(error) : castToValidationError(error);
                    }
                    return [];
                })
                .finally(() => {
                    setMultiLeadSending(false);
                });
        }

        if (props.recommendationType === ApplicationMultiLeadRecommendationType.OFFER) {
            return applicationMultiLeadSendOffer(
                {
                    selectedRecommendations:
                        "recommendedOffers" in sendMultiLeadFormParams && sendMultiLeadFormParams.recommendedOffers
                            ? sendMultiLeadFormParams.recommendedOffers || []
                            : recommendedOffers.filter((offer) => sendMultiLeadFormParams.selectedRecommendations?.includes(offer.id)),
                    formValues: sendMultiLeadFormParams.formValues
                },
                metadata
            )(dispatch)
                .then((response) => {
                    appendMultiLeadApplicationsForOffers(props.storeHash, response)(dispatch);

                    return response;
                })
                .catch(() => {
                    return [];
                })
                .finally(() => {
                    setMultiLeadSending(false);
                });
        }

        setMultiLeadSending(false);
        throw new Error("Unknown recommendation type");
    };

    return {
        sendMultiLeadForm,
        isMultiLeadSending,
        sentPropertiesApplications
    };
};
import {useState} from "react";
import {useDispatch} from "react-redux";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {castToValidationError} from "@pg-mono/react-hook-forms-utils";
import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils/src/utils/is_fetch_base_query_error";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Currency} from "../../../types/Currency";
import {appendMultiLeadApplicationsForOffers, appendMultiLeadApplicationsForProperties} from "../../actions/multi_lead/append_multi_lead_applications";
import {RecommendedOfferApplicationsType} from "../../actions/multi_lead/track_recommended_offers_application";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {applicationMultiLeadSendOffer} from "../../utils/multi_lead/application_multi_lead_send_offer";
import {applicationMultiLeadSendProperty} from "../../utils/multi_lead/application_multi_lead_send_property";
import {useMultiLeadData} from "./use_application_multi_lead_data";
import {useMultiLeadRecommendations} from "./use_application_multi_lead_recommendations";

interface IProps {
    storeHash: string;
    recommendationType: ApplicationMultiLeadRecommendationType;
    sourceSection: ApplicationSourceSection;
    originalApplicationFormValues: IApplicationFormValues | null;
    recommendationsWithPriceFilter: boolean;
    customSourceSection?: string;
    currency?: Currency;
    castRtkError?: (error: FetchBaseQueryError) => void;
}

type ISendMultiLeadFormParams =
    | {
          selectedRecommendations: number[];
          recommendedProperties?: never;
          recommendedOffers?: never;
          formValues: IApplicationFormValues;
      }
    | {
          selectedRecommendations?: never;
          recommendedProperties?: IRecommendedProperty[];
          recommendedOffers?: IRecommendedOffer[];
          formValues: IApplicationFormValues;
      };

export interface IMultiLeadApiErrors {
    fieldErrors?: {
        [key: string]: string[];
    };
    nonFieldErrors?: string[];
    status: number;
}

export const useMultiLeadFormSend = (props: IProps) => {
    const dispatch = useDispatch();
    const [isMultiLeadSending, setMultiLeadSending] = useState(false);
    const [sentPropertiesApplications, setSentPropertiesApplications] = useState<ApplicationMultiLeadRecommendedPropertyType[]>([]);

    const {applicationData, viewType, isAuthenticated} = useMultiLeadData(props);
    const {recommendedOffers, recommendedProperties} = useMultiLeadRecommendations({
        propertyId: applicationData?.property?.detail?.id,
        offerId: applicationData?.offer?.detail?.id
    });
    const refererApplicationUUID = applicationData?.application?.uuid;

    const sendMultiLeadForm = async (
        sendMultiLeadFormParams: ISendMultiLeadFormParams
    ): Promise<ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]> => {
        setMultiLeadSending(true);

        const metadata = {
            sourceSection: props.sourceSection,
            viewType,
            isAuthenticated,
            application: applicationData?.application,
            refererApplicationUUID,
            originalFormParams: {
                rooms: props.originalApplicationFormValues?.rooms || [],
                questions: props.originalApplicationFormValues?.questions || []
            },
            recommendationsWithPriceFilter: props.recommendationsWithPriceFilter,
            currency: props.currency
        };

        if (props.recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY) {
            return applicationMultiLeadSendProperty(
                {
                    recommendedProperties:
                        "recommendedProperties" in sendMultiLeadFormParams && sendMultiLeadFormParams.recommendedProperties
                            ? sendMultiLeadFormParams.recommendedProperties || []
                            : recommendedProperties.filter((property) => sendMultiLeadFormParams.selectedRecommendations?.includes(property.id)),
                    formValues: sendMultiLeadFormParams.formValues
                },
                metadata,
                props.customSourceSection
            )(dispatch)
                .then((response) => {
                    appendMultiLeadApplicationsForProperties(props.storeHash, response)(dispatch);

                    setSentPropertiesApplications((prev) => [...prev, ...response]);

                    return response;
                })
                .catch((error) => {
                    if (isFetchBaseQueryError(error) && error.status === 400) {
                        throw props.castRtkError ? props.castRtkError(error) : castToValidationError(error);
                    }
                    return [];
                })
                .finally(() => {
                    setMultiLeadSending(false);
                });
        }

        if (props.recommendationType === ApplicationMultiLeadRecommendationType.OFFER) {
            return applicationMultiLeadSendOffer(
                {
                    selectedRecommendations:
                        "recommendedOffers" in sendMultiLeadFormParams && sendMultiLeadFormParams.recommendedOffers
                            ? sendMultiLeadFormParams.recommendedOffers || []
                            : recommendedOffers.filter((offer) => sendMultiLeadFormParams.selectedRecommendations?.includes(offer.id)),
                    formValues: sendMultiLeadFormParams.formValues
                },
                metadata
            )(dispatch)
                .then((response) => {
                    appendMultiLeadApplicationsForOffers(props.storeHash, response)(dispatch);

                    return response;
                })
                .catch(() => {
                    return [];
                })
                .finally(() => {
                    setMultiLeadSending(false);
                });
        }

        setMultiLeadSending(false);
        throw new Error("Unknown recommendation type");
    };

    return {
        sendMultiLeadForm,
        isMultiLeadSending,
        sentPropertiesApplications
    };
};
